"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numeral = _interopRequireDefault(require("numeral"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var FrequencyTable = function FrequencyTable(props) {
  var data = props.data,
    showPercentage = props.showPercentage;
  var _useMemo = (0, _react.useMemo)(function () {
      var sum = data.reduce(function (num, item) {
        return num + item.value;
      }, 0);
      var result = data.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          percentage: sum > 0 ? item.value / sum * 100 : 0
        });
      });
      return {
        adjustedData: result,
        total: sum,
        hasCode: data.some(function (item) {
          return item.code;
        })
      };
    }, [data]),
    adjustedData = _useMemo.adjustedData,
    total = _useMemo.total,
    hasCode = _useMemo.hasCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: 'table table-condensed ' + _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Value"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Frequency"), showPercentage && /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Percentage"))), /*#__PURE__*/_react["default"].createElement("tbody", null, adjustedData.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: (0, _classnames["default"])(row.isOthers && _style["default"].others)
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.label), hasCode && 'code' in row && " (".concat(row.code, ")")), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, row.value), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, (0, _numeral["default"])(row.percentage).format('0.0'), "%"));
  })), /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, "TOTAL"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, total), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, "100%")))));
};
FrequencyTable.propTypes = {
  data: _propTypes["default"].array,
  showPercentage: _propTypes["default"].bool
};
var _default = FrequencyTable;
exports["default"] = _default;